// @i18n-ignore-file
// Constants
import { ExperimentConfiguration } from '../experiments.types'

import EXPERIMENTS from './experiments'

// Types

const EXPERIMENT_CONFIG_LIST: ExperimentConfiguration[] = [
  {
    name: 'hybrid-mte',
    date: '2024-02-06',
    buckets: [
      { name: 'show', ratio: 50 },
      { name: 'control', ratio: 50 },
    ],
  },
  {
    name: 'pdp-rec-modules',
    date: '2024-03-05',
    buckets: [
      { name: 'show', ratio: 50 },
      { name: 'control', ratio: 50 },
    ],
  },
  {
    name: 'pdp-new-tab',
    date: '2024-03-05',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'show', ratio: 0 },
    ],
  },
  {
    name: 'default-cart-recommendation',
    date: '2024-04-30',
    buckets: [
      { name: 'show', ratio: 100 },
      { name: 'control', ratio: 0 },
    ],
  },
  {
    name: 'mini-pdp',
    date: '2024-04-05',
    buckets: [
      { name: 'control', ratio: 100 },
      { name: 'testA', ratio: 0 },
      { name: 'testB', ratio: 0 },
    ],
  },
  {
    name: 'pdp-comparison-section',
    date: '2024-07-03',
    buckets: [
      { name: 'control', ratio: 50 },
      { name: 'show', ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.REVIEW_HIGHLIGHTS_MOBILE.experimentName,
    date: '2024-05-28',
    buckets: [
      { name: EXPERIMENTS.REVIEW_HIGHLIGHTS_MOBILE.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.REVIEW_HIGHLIGHTS_MOBILE.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.REWARD_CREDIT_ON_CARTPAGE.experimentName,
    date: '2024-07-05',
    buckets: [
      { name: EXPERIMENTS.REWARD_CREDIT_ON_CARTPAGE.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.REWARD_CREDIT_ON_CARTPAGE.bucketNames.control, ratio: 50 },
    ],
  },
  {
    name: EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.experimentName,
    date: '2024-08-06',
    buckets: [
      { name: EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.bucketNames.show, ratio: 50 },
      { name: EXPERIMENTS.CREDIT_TAGS_ON_PRODUCT_CARD.bucketNames.control, ratio: 50 },
    ],
  },
]

Object.freeze(EXPERIMENT_CONFIG_LIST)

export default EXPERIMENT_CONFIG_LIST
